var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonCloudtrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_AWS-CloudTrail_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F8B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/48/Arch_AWS-CloudTrail_48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,41.9738788 L23,41.9738788 L23,39.9608181 L20,39.9608181 L20,41.9738788 Z M22,37.9477575 L28,37.9477575 L28,35.9346969 L22,35.9346969 L22,37.9477575 Z M46.96,30.0636056 C46.734,27.7294618 45.556,26.0133276 43.712,25.3922984 C42.238,24.8970855 40.629,25.1990446 39.351,26.1361243 C38.666,24.6927599 37.688,23.1115007 36.702,22.1331533 C33.472,18.9253412 29.741,18.1754761 25.616,19.9077148 C22.259,21.3118245 19.389,25.410416 19.036,29.1396108 C17.19,29.7938555 15.008,31.2412461 14.074,33.5411678 L15.926,34.3021047 C16.653,32.5114873 18.62,31.288553 20.247,30.8708429 C20.69,30.757105 21,30.3554994 21,29.895515 C21,26.8195584 23.566,22.9454232 26.385,21.7657697 C29.789,20.3354901 32.623,20.9092124 35.298,23.5664524 C36.359,24.6192831 37.535,26.7611796 38.06,28.2236682 C38.184,28.5719277 38.488,28.8225537 38.852,28.8779129 C39.222,28.9372982 39.579,28.783299 39.799,28.4873791 C40.616,27.3942872 41.929,26.9181984 43.078,27.3016864 C44.3,27.7123508 45,29.0248663 45,30.9020453 C45,31.3942387 45.354,31.8139618 45.836,31.8944842 C49.926,32.5789248 52,34.6151357 52,37.9477575 C52,43.7806007 46.611,43.9829133 46,43.9869394 L29,43.9869394 L29,46 L46,46 C48.767,46 54,44.3170813 54,37.9477575 C54,33.8421204 51.509,31.0661098 46.96,30.0636056 L46.96,30.0636056 Z M22,46 L26,46 L26,43.9869394 L22,43.9869394 L22,46 Z M25,41.9738788 L36,41.9738788 L36,39.9608181 L25,39.9608181 L25,41.9738788 Z M11,41.9738788 L18,41.9738788 L18,39.9608181 L11,39.9608181 L11,41.9738788 Z M13,37.9477575 L19,37.9477575 L19,35.9346969 L13,35.9346969 L13,37.9477575 Z M14,46 L20,46 L20,43.9869394 L14,43.9869394 L14,46 Z M10,46 L12,46 L12,43.9869394 L10,43.9869394 L10,46 Z",
    id: "AWS-CloudTrail_Icon_48_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonCloudtrail);
export default __webpack_public_path__ + "static/media/amazon_cloudtrail.26d9ae95b52f16f31bfbba95bfb0f69a.svg";
export { ForwardRef as ReactComponent };